/** Size of one map tile in source pixels. */
export const TILE_SIZE = 16;

/** Tiles visible across the portrait screen. Maps are designed to fit this width. */
export const VIEW_TILES_WIDE = 12;

/** Internal (pre-scaling) game width in pixels. */
export const GAME_WIDTH = TILE_SIZE * VIEW_TILES_WIDE;

/** Shortest supported portrait height: 3:4 (tablets). */
export const MIN_GAME_HEIGHT = 256;

/** Tallest supported portrait height: 9:21 (tall phones). */
export const MAX_GAME_HEIGHT = 448;

/** Height used when the viewport is landscape (desktop browsers): 9:16. */
export const LANDSCAPE_FALLBACK_HEIGHT = 342;

export interface GameSize {
  width: number;
  height: number;
}

/**
 * Picks the internal game resolution for a viewport. Width is fixed so maps always fit
 * horizontally; height stretches to fill the device's aspect ratio (within limits) so tall phones
 * see more lawn rather than letterbox bars. Heights are kept even to avoid half-pixel centering.
 */
export function computeGameSize(viewportWidth: number, viewportHeight: number): GameSize {
  if (viewportWidth <= 0 || viewportHeight <= 0 || viewportHeight < viewportWidth) {
    return { width: GAME_WIDTH, height: LANDSCAPE_FALLBACK_HEIGHT };
  }
  const nearestEven = Math.round((GAME_WIDTH * viewportHeight) / viewportWidth / 2) * 2;
  const height = Math.min(MAX_GAME_HEIGHT, Math.max(MIN_GAME_HEIGHT, nearestEven));
  return { width: GAME_WIDTH, height };
}

/**
 * Height of the HUD band at the top of the screen (two rows + a 1 px rule); the lawn camera sits
 * below it.
 */
export const HUD_HEIGHT = 28;

/** Height of the tool bar at the bottom of the screen (only when tools are carried). */
export const TOOLBAR_HEIGHT = 24;
